import cn from 'classnames'
import { type ReactElement } from 'react'
import { RecurringPaymentStatus } from '../../../../../../../../../../shared/types/GlobalRecurringPaymentsStatus'
import { usdFormatter } from '../../../../../../../../../../shared/utils/formattingUtils'
import { type RecurringPayment } from '../../../../../../../../../../shared/proxies/recurringPaymentProxy'
import { determineTextColorClass } from './utils'

interface AmountCellProps {
  recurringPayment: RecurringPayment
}

export function RecurringPaymentsAmountCell ({ recurringPayment }: AmountCellProps): ReactElement {
  return (
    <td
      className={
        cn(
          'px-3 font-semibold',
          determineTextColorClass(recurringPayment),
          recurringPayment.status === RecurringPaymentStatus.Paused && 'italic'
        )
      }
    >
      {usdFormatter.format(recurringPayment.amountCents)}
    </td>
  )
}
